<script>
  import {Bar} from 'vue-chartjs'

  export default {
    name: "VendasPagamento",
    extends: Bar,
    props: ['dados'],

    computed: {
      chartData() {
        return this.dados;
      },
    },

    methods: {
      renderizarGrafico() {
        const labels = this.chartData.map(p => p.nome_pagamento || '');
        const values = this.chartData.map(p => p.valor || '0');

        const data = {
          labels,
          datasets: [{
            data: values,
            backgroundColor: ['#9454F0', '#1cc88a', '#f6c23e', '#2D3356', '#9454F0', '#1cc88a', '#f6c23e', '#2D3356', '#ff3244'],
            hoverBorderColor: "rgba(234, 236, 244, 1)"
          }],
        };

        const options = {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: -10
            }
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              },
              ticks: {
                display: false
              }
            }],
            yAxes: [{
              ticks: {
                display: false,
                beginAtZero: true
              },
              gridLines: {
                color: '#F8F9FC',
                zeroLineColor: "rgb(234, 236, 244)",
                drawBorder: false
              }
            }]
          },
          tooltips: {
            backgroundColor: "rgb(255,255,255)",
            bodyFontColor: "#858796",
            titleMarginBottom: 10,
            titleFontColor: '#6e707e',
            titleFontSize: 14,
            borderColor: '#dddfeb',
            borderWidth: 1,
            xPadding: 15,
            yPadding: 15,
            displayColors: false,
            intersect: false,
            mode: 'index',
            caretPadding: 10,
            callbacks: {
              label: (tooltipItem, chart) => {
                return 'R$ ' + tooltipItem.yLabel.toFixed(2);
              }
            }
          }
        };

        this.renderChart(data, options)
      }
    },

    watch: {
      dados() {
        this.$data._chart.destroy();
        this.renderizarGrafico();
      }
    },

    mounted() {
      this.renderizarGrafico();
    },
  }
</script>
